import { AuthParams } from '../../types';
import AuthGuardClientCheck from './client-check';

export default function AuthGuard({
  authParams = { pageType: 'privateOnly' },
  children,
  hideCallbackUrl = false,
  redirectTo = '/login',
}: {
  authParams?: AuthParams;
  children: React.ReactNode;
  hideCallbackUrl?: boolean;
  redirectTo?: string;
}) {
  return (
    <AuthGuardClientCheck
      authParams={authParams}
      hideCallbackUrl={hideCallbackUrl}
      redirectTo={redirectTo}
    >
      {children}
    </AuthGuardClientCheck>
  );
}
